const DEFAULT_SITE_LANG = "EN";
const DEFAULT_LOCALE = "en_EN";
const BETBUILDER_DEFAULT_LOCALE = "en-GB";
const GAME_NAME = "{ gamename }";
var FeaturesList = /* @__PURE__ */ ((FeaturesList2) => {
  FeaturesList2["eParaksts"] = "eParaksts";
  return FeaturesList2;
})(FeaturesList || {});
var ProjectBaseCurrency = /* @__PURE__ */ ((ProjectBaseCurrency2) => {
  ProjectBaseCurrency2["EUR"] = "EUR";
  return ProjectBaseCurrency2;
})(ProjectBaseCurrency || {});
const _route_ = (route) => route;
const getBaseLang = () => (window.language || DEFAULT_SITE_LANG).toLowerCase();
const getIsMobile = () => !!window.isMobile;
const getIsPrerender = () => !!window.isPrerender;
const defaultGameFilter = () => getIsMobile() ? { is_mobile: 1 } : { is_desktop: 1 };
const getBaseLocale = () => window.locale || DEFAULT_LOCALE;
const getPrimaryLang = () => (window.primaryLanguage || DEFAULT_SITE_LANG).toLowerCase();
const getBaseLangIso = () => (window.langIso || DEFAULT_SITE_LANG).toLowerCase();
const platformDeepLink = (domain, link) => `${domain}:///${link}`;
const getSelectorsByUserAgent = (ua = navigator.userAgent) => {
  const lowerUA = ua.toLowerCase();
  const isAndroid = /android/.test(lowerUA);
  const isIOS = /(iphone|ipad|ipod)/.test(lowerUA);
  const isMobile = isAndroid || isIOS || /mobile/.test(lowerUA);
  const isSafari = /safari/.test(lowerUA) && !/chrome|crios|android/.test(lowerUA);
  return { isMobile, isAndroid, isIOS, isSafari };
};
const clearPathFromParams = (path) => {
  return path.substring(0, path.indexOf("/:") + 1);
};
export {
  BETBUILDER_DEFAULT_LOCALE,
  DEFAULT_LOCALE,
  DEFAULT_SITE_LANG,
  FeaturesList,
  GAME_NAME,
  ProjectBaseCurrency,
  _route_,
  clearPathFromParams,
  defaultGameFilter,
  getBaseLang,
  getBaseLangIso,
  getBaseLocale,
  getIsMobile,
  getIsPrerender,
  getPrimaryLang,
  getSelectorsByUserAgent,
  platformDeepLink
};
